import React from "react";
import * as CSS from "csstype";

import {
  BoxProps,
  Text,
  HeadingProps,
  Stack,
  StackDirection,
} from "@chakra-ui/react";

import { mobileStyleBreakpoint } from "util/styleHelpers";

type PageHeadingProps = {
  children: React.ReactNode;
} & HeadingProps;

const pageTitleTextStyle = mobileStyleBreakpoint("h3", "h1");

const PageTitle = ({
  children,
  ...props
}: PageHeadingProps): React.ReactElement => (
  <Text w="100%" textStyle={pageTitleTextStyle} {...props}>
    {children}
  </Text>
);

type PageHeaderProps = { children: React.ReactNode } & Partial<BoxProps>;

const pageHeaderDirection = mobileStyleBreakpoint<CSS.Property.FlexDirection>(
  "column",
  "row"
) as StackDirection;
const pageHeaderAlignItems = mobileStyleBreakpoint<CSS.Property.AlignItems>(
  "flex-start",
  "center"
);
const pageHeaderPadding = mobileStyleBreakpoint(0, 16);

const PageHeader = ({
  children,
  ...props
}: PageHeaderProps): React.ReactElement => (
  <Stack
    as="header"
    direction={pageHeaderDirection}
    align={pageHeaderAlignItems}
    justify="space-between"
    py={pageHeaderPadding}
    spacing={8}
    {...props}
  >
    {children}
  </Stack>
);

const Page = ({
  children,
  ...props
}: { children: React.ReactNode } & Partial<BoxProps>): React.ReactElement => (
  <Stack w="100%" spacing={0} {...props}>
    {children}
  </Stack>
);

Page.Title = PageTitle;
Page.Header = PageHeader;

export default Page;
